import { BAPI_COMMANDS } from "../../types/commands";
import type { Result } from "../../types";
import { fetchHandler } from "@/bapi-client/fetch";
import type { UserMe } from "@/bapi-client/types/user";

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export async function loginOAuthUser(credentials: any): Promise<Result<UserMe>> {
  const response = await fetchHandler(BAPI_COMMANDS.USER_OAUTH_LOGIN, "POST", "/user/login/wabtec/token", {
    body: credentials,
  });
  if (!response.success) return response;
  const parsed = await response.data.json();
  return parsed;
}
